'use client'

import { AlertCircle } from 'lucide-react'
import { useChunkRecovery } from '@/lib/use-chunk-recovery'

/**
 * Boundary for every localised route that doesn't ship its own error.tsx.
 * Without this, failures here escaped to app/global-error.tsx, which replaces
 * the whole document and loses the layout.
 */
export default function LocaleError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  // A reload is in flight — render nothing rather than flashing an error card.
  if (useChunkRecovery(error)) return null

  return (
    <div className="min-h-screen bg-background text-white flex items-center justify-center px-6">
      <div className="max-w-md w-full rounded-2xl border border-white/10 bg-card/70 p-8 text-center">
        <AlertCircle className="w-10 h-10 text-primary mx-auto mb-4" />
        <h1 className="text-2xl font-bold mb-3">Something went wrong</h1>
        <p className="text-white/60 mb-6">
          We&apos;ve been notified and are looking into it.
        </p>
        <button
          type="button"
          onClick={reset}
          className="inline-flex items-center justify-center rounded-lg bg-primary px-5 py-2.5 text-sm font-bold hover:bg-primary/90 transition-colors"
        >
          Try Again
        </button>
      </div>
    </div>
  )
}
